// extracted by mini-css-extract-plugin
export default {"noWrap":"WYhJZZ","ctaLink":"pXHfQW"};